import axios from "axios";
import store from "@/store";
import router from "@/router";
import { showFailToast } from 'vant';
const user_http = axios.create({
    // https://vx.lol14.com
    baseURL: "https://vx.lol14.com/api"
})

const v_http = axios.create({
    baseURL: "https://vx.lol14.com/videos"
})

const captcha_http = axios.create({
    baseURL: 'https://vx.lol14.com/x/v1'
})

user_http.interceptors.request.use(config=>{
    const token = store.getters.getToken
    if (token) {
        config.headers.Authorization = 'Bearer '+ token
    }
    return config
}, err=>{
    return Promise.reject(err)
})

v_http.interceptors.request.use(config=>{
    const token = store.getters.getToken
    if (token) {
        config.headers.Authorization = 'Bearer '+ token
    }
    return config
}, err=>{
    return Promise.reject(err)
})

user_http.interceptors.response.use(function (res){
    // if (res.data.code === -101) {
    //     router.push('/login');
    //     showFailToast('请重新登录')
    // }
    return res;
}, function (err){
    if (err.response.status==-101) {
        router.push('/login');
        showFailToast('请重新登录')
    }
})

v_http.interceptors.response.use(function (res){

    return res;
}, function (err){
    if (err.response.status==-101) {
        router.push('/login');
        showFailToast('请重新登录')
    }
})

const getUserInfo = async () => {
    try {
        const res = await user_http.get(`/user/info`);
        if (res.data.code === 0) {
            const userData = res.data.data;
            await store.dispatch('login', {
                user: userData,
            });
        }
        return res.data.code;
    } catch (error) {
        console.error('Failed to fetch user info:', error);
        showFailToast("网络链接失败!请检查网络！或稍后再试");
        return -1;
    }
};

export {
    captcha_http,
    user_http,
    v_http,
    getUserInfo
}
